import {
  BodyMedium,
  ErrorCircleFilledIcon,
  iconColors,
  iconSizes
} from '@animoto/components';
import React from 'react';

import {
  icon,
  message,
  wrapper
} from './VideoUnavailable.module.css';

/**
 * Zero state component displayed when a video is unavailable on the play page.
 * Shown when the video owner lacks the link_share entitlement, or when the
 * video has been deleted, archived, or cannot be loaded.
 * @returns {JSX.Element} React component
 */
export default function VideoUnavailable() {
  return (
    <div className={wrapper}>
      <ErrorCircleFilledIcon className={icon} color={iconColors.ON_FILLED} size={iconSizes.MEDIUM} />
      <BodyMedium className={message} isInverted>
        This video is no longer available. Please contact the video creator.
      </BodyMedium>
    </div>
  );
}
